<!-- user-family-request-card.component.html -->
<div class="user-bcitiCard">
    <div class="avatar-container">
        <div class="avatar">
            <img class="user-avatar" [src]="user?.picture || 'https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png'" alt="user-avatar">
            <a [routerLink]="citizenProfileLink"
               target="_blank"
               class="profile-link">
                <mat-icon>open_in_new</mat-icon>
            </a>
        </div>
        <div class="card-number-container">
            <!-- Loading indicator -->
            <div *ngIf="!dataReady" class="loading-cards">
                <span class="icon-spinner spin"></span>
            </div>
            
            <!-- Card display -->
            <div *ngIf="dataReady">
                <div *ngFor="let cardInfo of userCards" [ngClass]="'card-' + cardInfo.type">
                    <span *ngIf="cardInfo.card" [ngClass]="getCardIcon(cardInfo.type)"></span>
                    <span *ngIf="cardInfo.card?.status === CardStatus.ACTIVE && cardInfo.card.code">
                        {{ cardInfo.card.code }}
                    </span>
                    <span *ngIf="cardInfo.card?.status === CardStatus.ACTIVE && !cardInfo.card.code">
                        {{ 'pages.userRecords.chips.numberNotGenerated' | translate }}
                    </span>
                    <span *ngIf="cardInfo.card && cardInfo.card.status !== undefined && cardInfo.card.status !== CardStatus.ACTIVE">
                        {{ 'pages.userRecords.card.status.' + cardInfo.card.status | translate }}
                    </span>
                </div>
                <div class="card-BCITI" *ngIf="!hasAnyCards()">
                    <span class="icon-my-card"></span>
                    <span>{{ 'pages.userRecords.chips.noCardNumber' | translate }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="info">
        <!-- Family link type -->
        <div class="row">
            <div class="row-item">
                <h6>{{'pages.userFamily.linkType' | translate}}:</h6>
                <div class="link-display" *ngIf="!editing">
                    <p class="bold">{{ link ? ('pages.userFamily.linksType.' + (link | lowercase) | translate) : ('pages.userRecords.card.status.na' | translate) }}</p>
                    <button *ngIf="editable" class="edit-link-btn" (click)="editing = true">
                        <mat-icon>edit</mat-icon>
                    </button>
                </div>
                <div class="link-edit" *ngIf="editing">
                    <div class="link-options">
                        <button
                            *ngFor="let option of familyLinkOptions"
                            class="link-option"
                            [class.selected]="option === link"
                            (click)="onLinkSelect(option)">
                            {{ 'pages.userFamily.linksType.' + (option | lowercase) | translate }}
                        </button>
                    </div>
                    <button class="cancel-edit-btn" (click)="editing = false">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <!-- User information -->
        <ng-container *ngIf="dataReady; else loadingState">
            <div class="row">
                <div class="row-item">
                    <h6>{{ 'common.fields.firstName' | translate }}:</h6>
                    <p class="bold">{{ user?.firstName || ('pages.userRecords.card.status.na' | translate) }}</p>
                </div>
                <div class="row-item">
                    <h6>{{ 'common.fields.lastName' | translate }}:</h6>
                    <p class="bold">{{ user?.lastName || ('pages.userRecords.card.status.na' | translate) }}</p>
                </div>
            </div>

            <div class="row">
                <div class="row-item">
                    <h6>{{ 'common.fields.sex' | translate }}:</h6>
                    <p>{{ user?.sex ? ('common.' + user?.sex | translate) : ('pages.userRecords.card.status.na' | translate) }}</p>
                </div>

                <div class="row-item">
                    <h6>{{ 'common.fields.birthdate' | translate }}:</h6>
                    <p class="semi-bold">{{ user?.birthDate ? (user?.birthDate | localizedDate) : ('pages.userRecords.card.status.na' | translate) }}</p>
                </div>
            </div>

            <div class="row">
                <div class="row-item">
                    <h6>{{ 'common.fields.email' | translate }}:</h6>
                    <p>{{ user?.email || ('pages.userRecords.card.status.na' | translate) }}</p>
                </div>
            </div>

            <!-- Address with warning when needed -->
            <div class="row">
                <div class="row-item">
                    <h6>{{ 'common.fields.address-short' | translate }}:</h6>
                    <div class="address-container">
                        <p>{{ formatAddress(displayAddress) }}</p>
                    </div>
                    <p *ngIf="isProfileAddress" class="address-warning">
                        <span class="warning-icon icon-warning"></span>
                        {{ 'pages.userRecords.card.addressWarning' | translate }}
                    </p>
                </div>
            </div>

            <!-- Invitation not accepted warning -->
            <div class="row" *ngIf="familyApproved === false">
                <div class="row-item">
                    <p class="address-warning">
                        <span class="warning-icon icon-warning"></span>
                        {{ 'pages.userFamily.invitationNotAccepted' | translate: { name: user?.firstName } }}
                    </p>
                </div>
            </div>
        </ng-container>

        <!-- Loading state -->
        <ng-template #loadingState>
            <div class="loading-container">
                <span class="icon-spinner spin"></span>
                <p>{{ 'common.loading' | translate }}</p>
            </div>
        </ng-template>
    </div>
</div>